import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import {
	Alert,
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { changeKitchenItemsStatus } from '../../../../../services/Admin/OrderProcessingScreensApi';


const ChangeOrderItemsStatue = ({
	open,
	onClose,
	orderId,
	orderData,
	items = [],
	status = 'out_of_preparation',
	onSuccess,
}) => {
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState('');
	const hasSubmittedRef = useRef(false);

	const itemIds = useMemo(
		() => (Array.isArray(items) ? items.map((item) => item.id).filter(Boolean) : []),
		[items]
	);

	const orderPayload = useMemo(() => {
		if (!orderData?.id) {
			return null;
		}

		return {
			order_id: orderData.id,
			status: 'out_of_preparation',
			table_id: orderData.table_id ?? null,
			captain_order_id: orderData.captain_order_id ?? null,
			delivery_id: orderData.delivery_id ?? null,
			date: orderData.date,
			order_type: orderData.order_type,
		};
	}, [orderData]);

	const handleConfirm = useCallback(async () => {
		setError('');

		if (itemIds.length === 0) {
			setError('لا توجد عناصر صالحة لتغيير الحالة.');
			return;
		}

		setLoading(true);
		try {
			await changeKitchenItemsStatus(itemIds, status);
			onSuccess?.();
			onClose?.();
		} catch (err) {
			console.error('خطأ في تغيير حالة عناصر الطلب:', err);
			setError(err.message || 'حدث خطأ أثناء تغيير حالة الطلب.');
		} finally {
			setLoading(false);
		}
	}, [itemIds, onClose, onSuccess, orderPayload, status]);

	useEffect(() => {
		if (!open) {
			hasSubmittedRef.current = false;
			setError('');
			return;
		}

		if (hasSubmittedRef.current) {
			return;
		}

		hasSubmittedRef.current = true;
		handleConfirm();
	}, [handleConfirm, itemIds, open, status]);

	if (!open || (!error && loading)) {
		return null;
	}

	if (!open || (!error && !loading)) {
		return null;
	}

	return (
		<Dialog open={open && Boolean(error)} onClose={loading ? undefined : onClose} maxWidth="sm" fullWidth>
			<DialogTitle sx={{ fontWeight: 700, textAlign: 'right' }}>
				فشل تحديث الحالة
			</DialogTitle>

			<DialogContent dividers>
				<Alert severity="error" sx={{ direction: 'rtl' }}>
					{error || `تعذر تحديث حالة الصنف في الطلب #${orderId || '-'}`}
				</Alert>
			</DialogContent>

			<DialogActions sx={{ p: 2 }}>
				{error ? (
					<Button
						onClick={onClose}
						variant="outlined"
						color="inherit"
						startIcon={<CloseIcon />}
						disabled={loading}
					>
						إغلاق
					</Button>
				) : null}
			</DialogActions>
		</Dialog>
	);
};

export default ChangeOrderItemsStatue;
